const faqData = [
  {
    id: 1,
    q: '嫩草视频需要下载安装吗？',
    a: '不需要。嫩草视频是纯网页端影视聚合平台，无需下载任何 App 或安装插件，打开浏览器即可直接观看妖精视频、桃花视频等平台的热播影视内容。',
  },
  {
    id: 2,
    q: '平台上的影视资源画质如何？',
    a: '我们聚合的影视资源均支持高清 1080P 在线观看，部分热门剧集更提供超清画质选项。实际画质取决于源平台资源质量，我们优先收录高清资源。',
  },
  {
    id: 3,
    q: '更新速度怎么样？新剧多久能上线？',
    a: '团队每日监测妖精视频、桃花视频、苹果视频、榴莲视频等平台更新动态，热播剧集通常在源平台更新后 2-6 小时内完成收录，确保追剧不等待。',
  },
  {
    id: 4,
    q: '支持哪些视频平台的资源？',
    a: '目前聚合了妖精视频、桃花视频、苹果视频、榴莲视频、豆花视频等 12 个主流影视平台的热播剧集和电影大全，后续将持续扩展更多平台。',
  },
  {
    id: 5,
    q: '是否需要注册或付费？',
    a: '嫩草视频作为影视资源聚合导航平台，浏览和查找影视内容完全免费。部分源平台可能需要注册或付费观看完整内容，请以源平台规则为准。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-question-line"></i>
            帮助中心
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            关于嫩草视频的常见疑问，这里都有解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 flex-shrink-0 mt-0.5">
                    <span className="text-background-50 text-xs font-heading">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-foreground-950 font-medium text-sm md:text-base mb-2">
                      {item.q}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}